"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const table_style_1 = require("../components/table/table.style");
const theme_1 = require("../components/theme");
exports.CSS = {
    container: 'c-OrgSearch',
    title: 'c-OrgSearch__Title',
    message: 'c-OrgSearch__Message',
    search: {
        container: 'c-OrgSearch__Search',
        row: 'c-OrgSearch_row',
        section: 'c-OrgSearch__section',
        sectionRight: 'c-OrgSearch__section--right'
    },
    table: 'c-OrgSearch__Table',
    tableCell: 'c-OrgSearch__TableCell',
    tableCellFaint: 'c-OrgSearch__TableCell--faint',
    tableCellGhost: 'c-OrgSearch__TableCell--ghost',
    tableCellRoleActions: 'c-OrgSearch__TableCellRole',
    box: {
        container: 'c-OrgSearch__Box',
        icon: 'c-OrgSearch__icon',
        input: 'c-OrgSearch__input',
        clear: 'c-OrgSearch__clear'
    }
};
const SPACE_10 = theme_1.DefaultTheme.space(10);
const SPACE_7 = theme_1.DefaultTheme.space(7);
exports.Style = {
    [exports.CSS.search.container]: {
        height: SPACE_10,
        'min-height': SPACE_10,
        'margin-left': '16px',
        'margin-right': '16px',
        color: 'rgba(255,255,255,0.97)',
        [`& .${exports.CSS.box.container}`]: {
            flex: '1',
            height: SPACE_7
        }
    },
    [exports.CSS.search.row]: {
        display: 'flex',
        'flex-direction': 'row',
        'align-items': 'center',
        height: SPACE_10,
        'padding-left': theme_1.DefaultTheme.space(14),
        'padding-right': theme_1.DefaultTheme.space(2),
        'min-height': SPACE_10,
        'background-color': theme_1.DefaultTheme.background.darkGrey,
        color: 'rgba(255,255,255,0.97)'
    },
    [exports.CSS.search.section]: {
        display: 'flex',
        flex: 1,
        'align-items': 'center'
    },
    [exports.CSS.search.sectionRight]: {
        'justify-content': 'flex-end'
    },
    [exports.CSS.box.container]: {
        'background-color': theme_1.DefaultTheme.background.mediumGrey,
        padding: `0 ${theme_1.DefaultTheme.space(2)}`,
        display: 'flex',
        'align-items': 'center',
        color: theme_1.DefaultTheme.font.color.white
    },
    [exports.CSS.box.input]: {
        flex: '1',
        border: 'none',
        outline: 'none',
        'background-color': 'transparent',
        'font-family': theme_1.DefaultTheme.font.family,
        'font-size': theme_1.DefaultTheme.font.size,
        color: theme_1.DefaultTheme.font.color.white,
        'margin-left': theme_1.DefaultTheme.space(4)
    },
    [`${exports.CSS.box.input}::placeholder`]: {
        opacity: '0.6',
        color: theme_1.DefaultTheme.font.color.white,
        transition: 'opacity 0.2s ease'
    },
    [exports.CSS.box.clear]: {
        color: theme_1.DefaultTheme.font.color.white
    },
    [`${exports.CSS.box.input}:focus::placeholder`]: {
        opacity: '0.8',
        color: theme_1.DefaultTheme.font.color.white
    },
    [exports.CSS.box.icon]: {
        'pointer-events': 'none'
    },
    [exports.CSS.container]: {
        [`& .${table_style_1.CSS.container}`]: {
            width: '80%',
            'margin-bottom': theme_1.DefaultTheme.space(6)
        },
        [`& .${table_style_1.CSS.cell}:nth-last-of-type(2)`]: {
            overflow: 'visible'
        }
    },
    [exports.CSS.tableCellFaint]: {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    [`${table_style_1.CSS.row}:hover .${exports.CSS.tableCellGhost}`]: {
        visibility: 'visible'
    },
    [exports.CSS.tableCellGhost]: {
        visibility: 'hidden'
    },
    [exports.CSS.tableCellRoleActions]: {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'flex-end',
        '& .mdl-button': {
            'font-size': 'inherit'
        }
    }
};
//# sourceMappingURL=org.search.style.js.map